module.exports = __webpack_public_path__ + "img/lg_ring_g_c_1_null.631e0bca.png";